import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PageHeader from '../components/PageHeader';
import ClientProfile from '../components/ClientProfile';
import ClientUserManagement from '../components/ClientUserManagement';
import ClientUsageStats from '../components/ClientUsageStats';
import Footer from 'components/PageFooter';

const ClientProfilePage: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const history = useHistory();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <PageHeader />

      <div className="flex-1 w-full max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{t('navigation.clientProfile')}</h2>
            <p className="text-gray-600 dark:text-gray-400">{t('clientProfile.manageProfile')}</p>
          </div>
          <button
            onClick={() => history.push('/api-management')}
            className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors text-sm font-medium flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
            </svg>
            Manage API Integrations
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-8">
            <ClientProfile clientId={user?.clientId?.toString()} />
            <ClientUsageStats />
          </div>
          <div>
            <ClientUserManagement />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClientProfilePage;
